// Single source of truth for GPS segment plausibility filtering.
// Used by both the live tracker (useGPSTracking) and the Session Summary split calculator.

// Absolute cap: 8 m/s = 28.8 km/h — above any realistic dragon boat speed
export const MAX_SPEED_MS = 8;

const SPIKE_WINDOW = 8;      // rolling window of recent accepted implied speeds
const SPIKE_RATIO = 1.75;    // reject segments faster than 1.75x the rolling median
const MIN_SPIKE_FLOOR = 2.5; // never spike-reject below this speed (m/s)
const MIN_WINDOW_SIZE = 4;   // need this many accepted segments before spike check kicks in

// Stateful per-session segment filter. Create one instance per tracking session
// or per split computation, then call it for each consecutive GPS segment.
export const createSegmentFilter = () => {
  const recentSpeeds = [];
  return (segmentDistance, timeDiffSeconds, accuracy) => {
    if (!(segmentDistance > 0.5 && segmentDistance < 100)) return false;
    if (!(accuracy < 50)) return false;

    const impliedSpeed = timeDiffSeconds > 0 ? segmentDistance / timeDiffSeconds : 0;
    if (impliedSpeed >= MAX_SPEED_MS) return false;

    // Adaptive spike rejection: a single segment far above the recent steady pace
    // is a GPS fluctuation, not a real speed change
    if (recentSpeeds.length >= MIN_WINDOW_SIZE) {
      const sorted = [...recentSpeeds].sort((a, b) => a - b);
      const median = sorted[Math.floor(sorted.length / 2)];
      const threshold = Math.max(MIN_SPIKE_FLOOR, median * SPIKE_RATIO);
      if (impliedSpeed > threshold) return false;
    }

    recentSpeeds.push(impliedSpeed);
    if (recentSpeeds.length > SPIKE_WINDOW) recentSpeeds.shift();
    return true;
  };
};
